/* BEGIN html header helper */
(function($) {
    var HTML_Header = {
        config: {
            scrollThreshold: 20
        },

        scrollPositionBeforeMobileNavOpen: 0,

        init: function( options ){
            var self = this;
            $.extend( this.config, options );

            //Access this object globally
            //document.HTML_Header = this;


            $(document).ready(function() {
                self.initScrollUI();
                self.windowHeight = $(window).height();

                self
                    .initMobileMenuUI()
                    .setActivePage()
                    .toggleMobileSubmenu(); // must run after setActivePage()
            });

            $(window).resize(function(){
                self.windowHeight = $(window).height();

                self
                    .initMobileMenuUI()
                    .setIsMobileClass()
                    .toggleMobileSubmenu();
            });

        },

        /**
         * Apply .scrolling class when page is not scrolled to top of page
         *
         * @returns {HTML_Header}
         */
        initScrollUI: function() {
            var self = this;

            self.setScrollingClass();
            $(window).scroll(function() {
                self.setScrollingClass();
            });

            return this;
        },

        /**
         * Toggle .open-mobile-menu class when menu icon clicked
         *
         * @returns {HTML_Header}
         */
        initMobileMenuUI: function() {
            var self = this;

            self.setIsMobileClass();

            // Prevent .open-mobile-menu class toggle on desktop
            if (! self.isMobile()) {
                $('html').removeClass('open-mobile-menu');
                return self;
            }

            var scrollTopElement = self.getBrowserScrollElement();

            // .open-mobile-menu styles applied in _header.scss and _primary-nav.scss
            /**
             * Normally would use ".bind('click',function(){}) here, but there was
             * inconsistent behavior where the nav would not open on click. Using
             * ".click()" seems to behave.
             */
            $('#nav-icon').click( function(){
                if ($('html').hasClass('open-mobile-menu')) {
                    // Close menu
                    $('html').removeClass('open-mobile-menu');

                    // Close expanded menu items (unless child page is current)
                    $('.primary-nav > ul > li:not(".child-page-is-current")').removeClass('active');

                    /**
                     * To prevent the page from scrolling while the mobile nav is
                     * active, we apply overflow:hidden to <html> and <body>. This
                     * causes the page to jump back to the top. The following
                     * restores the page scroll position when closing the mobile
                     * menu.
                     */
                    $(scrollTopElement).scrollTop(self.scrollPositionBeforeMobileNavOpen);
                } else {
                    // Open menu
                    self.scrollPositionBeforeMobileNavOpen = $(scrollTopElement).scrollTop();
                    $('html').addClass('open-mobile-menu');
                }
            });

            return this;
        },

        /**
         * Determine if mobile based on CSS styles applied from media queries.
         * Not a true mobile detect but can be used to sync scripts to
         * responsive styles.
         *
         * @returns {boolean}
         */
        isMobile: function() {
            var self = this;
            if ( $('.primary-nav-toggle').css('display') == 'none') {
                return false;
            }
            return true;
        },

        /**
         * Accommodate for scroll handling from various elements based
         * on device
         *
         * @returns {string}
         */
        getBrowserScrollElement: function(){
            var self = this;

            /**
             * iOS handles scroll postion based on <body>, every other
             * browser uses <html>
             */
            if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
                return 'body';
            }

            return 'html';
        },

        /**
         * Identify nav links that match current page and
         * submenus that contain links with current page
         *
         * @returns {HTML_Header}
         */
        setActivePage: function() {
            var self = this;

            self.currentPage = location.pathname
                .substr(1)
                .replace(/\/$/, "");

            if (self.currentPage == '') {
                self.currentPage = 'homepage';
            }

            // Identify any current page matches in nav
            $('.primary-nav a[href="/' + self.currentPage + '"]').addClass('current-page');

            // Search submenus to identify if any children are current page
            $('.primary-nav > ul > li.has-children').each(function(){
                if ($(this).find('a.current-page').length !== 0) {
                    $(this).addClass('child-page-is-current');
                }
            });

            //console.log(self);

            return this;
        },

        /**
         * @returns {boolean}
         */
        setIsMobileClass: function() {
            var self = this;

            $('html')
                .removeClass('is-desktop')
                .removeClass('is-mobile');

            if (self.isMobile()) {
                $('html').toggleClass('is-mobile');
            } else {
                $('html').toggleClass('is-desktop');
            }

            return this;
        },

        setScrollingClass: function() {
            var self = this;

            var scroll = $(window).scrollTop();

            if (scroll >= self.config.scrollThreshold) {
                $("body").addClass("scrolling");
            } else {
                $("body").removeClass("scrolling");
            }

            return this;
        },

        /**
         * Apply .active class to clicked main level links to
         * trigger submenu display.
         *
         * Must initialize AFTER this.setActivePage()
         *
         * @returns {HTML_Header}
         */
        toggleMobileSubmenu: function() {
            var self = this;

            $('.primary-nav > ul > li > a').unbind('click');

            if (! self.isMobile()) {
                $('.primary-nav > ul > li').removeClass('active');
                return this;
            }

            // Auto expand submenu if a menu item matches current page
            $('.primary-nav > ul > li.child-page-is-current').addClass('active');

            $('.primary-nav > ul > li > a').bind('click', function(event){
                $(this).parent().toggleClass('active');
            });

            return this;
        }
    }.init();
})(jQuery);
/* End html header helper */